'use client'
import "./NavigationBar.css";
import {React} from "react";
import Link from "next/link";
import { useUser } from "@/Context/UserContext";

/**
 * @description The NavigationBar component is a container for the navigation bar. Other navigation components go into it which takes the user elsewhere.
 * @returns {JSX.Element}The NavigationBar component.
 */
export default function NavigationBar() {
  const { username } = useUser();

  return (
    <div className="NavigationBar">
      <Link href="/" className="NavButtonLink">
        <button
          className="NavButton"
          id="HomeButton"
        >
          Home
        </button>
      </Link>
      <Link href="/Account" className="NavButtonLink">
        <button className="NavButton" id="AccountButton">
          Account
        </button>
      </Link>
      <Link href="/" className="NavButtonLink">
        <button className="NavButton" id="SettingButton">
          Settings
        </button>
      </Link>
      {username && (
        <span className="NavUser">{username}</span>
      )}
    </div>
  )
}